var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h116v116H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58 105.949c-26.481 0-47.949-21.468-47.949-47.949 0-26.481 21.468-47.949 47.949-47.949 26.481 0 47.949 21.468 47.949 47.949 0 26.481-21.468 47.949-47.949 47.949m53.438-70.528a57.793 57.793 0 0 0-12.426-18.433A57.794 57.794 0 0 0 80.58 4.562C73.422 1.535 65.826 0 58 0c-7.826 0-15.422 1.535-22.58 4.562a57.795 57.795 0 0 0-18.432 12.426A57.793 57.793 0 0 0 4.562 35.42C1.535 42.578 0 50.174 0 58c0 7.825 1.535 15.422 4.562 22.58a57.793 57.793 0 0 0 12.426 18.432 57.796 57.796 0 0 0 18.433 12.426C42.578 114.465 50.174 116 58 116c7.826 0 15.422-1.535 22.58-4.562a57.795 57.795 0 0 0 18.432-12.426 57.793 57.793 0 0 0 12.426-18.433C114.465 73.422 116 65.825 116 58c0-7.826-1.535-15.422-4.562-22.58",
    fill: "#FC5726",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.54 34.46a4.984 4.984 0 0 0-7.048 0L58.5 51.452 41.508 34.46a4.984 4.984 0 0 0-7.048 7.048L51.45 58.5 34.46 75.492a4.984 4.984 0 0 0 7.048 7.048L58.5 65.548 75.492 82.54A4.969 4.969 0 0 0 79.016 84a4.984 4.984 0 0 0 3.524-8.508L65.548 58.5 82.54 41.508a4.984 4.984 0 0 0 0-7.048",
    fill: "#FC5726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSign);
export default __webpack_public_path__ + "static/media/error-sign.992f3ad9865fa07af090517f1e05c37c.svg";
export { ForwardRef as ReactComponent };